var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStudent = function SvgIconStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.684 2.051a1 1 0 0 1 .632 0l9 3a1 1 0 0 1 0 1.898L17.471 8.23a6.25 6.25 0 0 1-1.758 8.049 9.25 9.25 0 0 1 4.043 3.425 1 1 0 1 1-1.675 1.092 7.26 7.26 0 0 0-6.048-3.294h-.066a7.26 7.26 0 0 0-6.048 3.294 1 1 0 1 1-1.676-1.092 9.26 9.26 0 0 1 4.043-3.425A6.25 6.25 0 0 1 6.53 8.23L4 7.387V13.5a1 1 0 1 1-2 0V6a1 1 0 0 1 .706-.956zM8.522 6.787a1 1 0 0 0-.156-.052L6.162 6 12 4.054 17.838 6l-2.204.735a1 1 0 0 0-.156.051L12 7.947zm-.048 2.092a4.25 4.25 0 0 0 3.495 6.623h.062a4.25 4.25 0 0 0 3.495-6.623l-3.21 1.07a1 1 0 0 1-.632 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconStudent;